import Konva from 'konva';
import * as state from '../state.js';
import { attachInteractive, pointerPos } from './_helpers.js';

let active = null;
let startX = 0;
let startY = 0;

export const line = {
  id: 'line',
  defaultProps: { dashed: false },
  onPointerDown(engine) {
    const pos = pointerPos(engine);
    if (!engine.pointerInsideImage(pos)) return;
    startX = pos.x;
    startY = pos.y;
    const defaults = state.get('toolDefaults').line ?? this.defaultProps;
    active = new Konva.Line({
      points: [startX, startY, startX, startY],
      stroke: state.get('selectedColor'),
      strokeWidth: state.get('strokeWidth'),
      lineCap: 'round',
      lineJoin: 'round',
      dash: defaults.dashed ? [12, 8] : undefined,
    });
    engine.contentLayer.add(active);
  },
  onPointerMove(engine) {
    if (!active) return;
    const pos = pointerPos(engine);
    active.points([startX, startY, pos.x, pos.y]);
    engine.contentLayer.batchDraw();
  },
  onPointerUp(engine) {
    if (!active) return;
    const [x1, y1, x2, y2] = active.points();
    if (Math.hypot(x2 - x1, y2 - y1) < 4) {
      active.destroy();
    } else {
      active.remove();
      attachInteractive(engine, active);
    }
    engine.contentLayer.batchDraw();
    active = null;
  },
  apply(node, prop, value) {
    if (prop === 'color') {
      node.stroke(value);
    } else if (prop === 'strokeWidth') {
      node.strokeWidth(value);
    } else if (prop === 'dashed') {
      node.dash(value ? [12, 8] : undefined);
    }
  },
};
